<route>
{
  "name": "memberEdit",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.members.title')">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.name"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.name')"
        :placeholder="$t('models.name')"
      ></form-item>
      <form-item
        v-model="formData.phone"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.phone')"
        :placeholder="$t('models.phone')"
      ></form-item>
      <form-item
        v-model="formData.isadmin"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="checkbox"
        icon="mdi-form-textbox"
        :label="$t('models.isadmin')"
        :placeholder="$t('models.isadmin')"
      ></form-item>

      <removeConfirm
        @success="remove"
        @cancel="removeConfirmDialog = false"
        v-model="removeConfirmDialog"/>

      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
        <!--Disable Delete In UI-->
        <!--<v-btn-->
          <!--class="mr-auto"-->
          <!--@click="removeConfirmDialog = true"-->
          <!--color="error"-->
          <!--{{ $t('pages.forms.removeButtonText') }}-->
        <!--</v-btn>-->
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    removeConfirmDialog: false,
    formIsValid: true,
    formData: {
      name: '',
      password: '',
      phone: '',
    }
  }),
  computed: {
  },
  created () {
    this.preLoadData()
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('member/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.formData = response.data        
      })
    },
    update () {
      this.$store.dispatch('member/update', {
        id: this.$route.params.id,
        name: this.formData.name,
        isadmin: this.formData.isadmin,
        phone: this.formData.phone,
        password: this.formData.password
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    remove () {
      this.removeConfirmDialog = false
      this.$store.dispatch('member/remove', {
        id: this.$route.params.id
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    // NOTE: Keep this name same in all form pages and components
    onSubmitForm () {
      this.update()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
